import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import '../../common/css/timeLive.css'
import Select, { components, StylesConfig } from 'react-select';
import { useDropzone } from "react-dropzone";
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { getEmployeeProfileAsync, updateProfileAsync, UploadElectronicSignature, UploadProfile, IsCurrentPasswordValidate, GetEmailAddressValidationAsync } from './ProfileSlice';
import { ProfileInitialsForUpdate } from './interfaces/ProfileClass';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import fetchAPI from '../../common/fetchAPI';
import { ShowToast } from '../../common/Toastr';
import { ShowSwal, ShowSwalForCanvas } from '../../common/SweetAlert';
import { dropDownSelectionStyles, getValueFromResource } from '../../common/timeLiveFunction';
import Loader from '../../common/Loader';
import i18n from '../../i18n/config';
import { checkedshowAdminPagesState, getAccountFeatureAsync, UncheckedshowAdminPagesState } from '../../common/GlobalSlice';

const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, paddingLeft: '0px' })
}

export const Profile = () => {
    const { sessionAccountEmployeeId } = useAppSelector(state => state.globalState);
    const storedobjAdmin: any = localStorage.getItem('objAdmin');
    const isAdminOptionShow: boolean = storedobjAdmin ? JSON.parse(storedobjAdmin) : false;

    const [files, setFiles]: any = useState([]);
    const { i18n } = useTranslation();
    const { profileList, isReload, selectedRecord, IsAspNetActiveDirectoryMembershipProvider, isLoading } = useAppSelector((state) => state.profile);
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(ProfileInitialsForUpdate);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const [authTokenDiv, setAuthTokenDiv] = useState<boolean>(false);
    const [isEmailAvailabler, setisEmailAvailabler] = useState(true);
    const [isPasswordValidate, setisPasswordValidate] = useState(true);
    const {
        // accountPreferenceList ,
        enablePasswordComplexity, maxMenuHeight, enableUploadFeature, showEmployeeProfilePicture, profileURL, accountFeatureList } = useAppSelector((state) => state.globalState);
    const [isAttendanceFeature, setIsAttendanceFeature] = useState<boolean>(false);
     const { isUpdateData } = useAppSelector((state) => state.featureManagement);
     const isEnableAttandance = accountFeatureList.find((item)=> item.Name === 'Attendance')?.Name;
    // const [isEnableUploadFeature, setIsEnableUploadFeature] = useState<boolean>(false);
    // const [enablePasswordComplexity, setEnablePasswordComplexity] = useState<boolean>(false);


    const formik = useFormik({
        initialValues: currentFieldsData, // Pass your initialValues object
        enableReinitialize: true,
        validationSchema: yup.object().shape({
            FirstName: yup
                .string()
                .label(t('FirstName'))
                .trim()
                .required(t('First Name field is required')),
            LastName: yup
                .string()
                .label('LastName')
                .trim()
                .required(t('Last Name field is required')),
            EMailAddress: yup
                .string()
                .label('EMailAddress')
                .trim()
                .required(t('Email field is required')),

        }),
        onSubmit: (values, action) => {
            if (IsAspNetActiveDirectoryMembershipProvider === false) {
                if (passwordValidation(values)) {
                    handleSubmit(values);
                    action.resetForm();
                }
            }
            else {
                handleSubmit(values);
                action.resetForm();
            }
        },
    });



    const passwordValidation = (values: any) => {
        const passwordRegex = /^(?=^.{8,}$)(?=.*\d)(?=.*\W+)(?![.\n]).*$/;
        let isValid = true;

        // Default values to handle undefined
        const Password = values.Password || ""; // Treat undefined as empty string
        const NewPassword = values.NewPassword || ""; // Treat undefined as empty string
        const VerifyPassword = values.VerifyPassword || ""; // Treat undefined as empty string

        if (NewPassword || Password || VerifyPassword) {
            if (NewPassword) {
                if (!Password) {
                    ShowSwal("Error", "Current Password is required.", 'error');
                    isValid = false;
                }
                if (NewPassword !== VerifyPassword) {
                    ShowSwal("Error", "Confirm Password does not match.", 'error');
                    isValid = false;
                }
            }

            if (enablePasswordComplexity && isValid && NewPassword) {
                if (!passwordRegex.test(NewPassword)) {
                    ShowSwal("Error", "Password must be at least 8 characters long and contain at least one digit and one special character.", 'error');
                    isValid = false;
                }
            }

            // Prevent submission if only current password is entered
            if (!NewPassword && !VerifyPassword && Password) {
                ShowSwal("Error", "New Password and Confirm Password are required.", 'error');
                isValid = false;
            }
        }

        return isValid;
    };

    const [countryArray, SetCountryArray] = useState<any | ''>([]);
    const [TimeZoneArray, SetTimeZoneArray] = useState<any | ''>([]);

    const UserInterfaceLanguageOptions = [
        { label: 'English (United States)', value: 'en-US' },
        { label: 'German (Germany)', value: 'de-DE' },
        { label: 'French (France)', value: 'fr-FR' },
        { label: 'Chinese (Simplified, PRC)', value: 'zh-CN' },
        { label: 'Italian (Italy)', value: 'it-IT' },
        { label: 'Dutch (Netherlands)', value: 'nl-NL' },
        { label: 'Spanish (Spain)', value: 'es-ES' },
        { label: 'Swedish (Sweden)', value: 'sv-SE' },
        { label: 'Portuguese (Portugal)', value: 'pt-PT' },
        { label: 'Norwegian, Nynorsk (Norway)', value: 'nn-NO' },
        { label: 'Romanian (Romania)', value: 'ro-RO' },
        { label: 'Hungarian (Hungary)', value: 'hu-HU' },
        { label: 'Thai (Thailand)', value: 'th-TH' },
        { label: 'Turkish (Turkey)', value: 'tr-TR' },
        { label: 'Russian (Russia)', value: 'ru-RU' }
    ];

    const renderPreferenceFields = async () => {
        const response = await fetchAPI(`api/V2/Employees/AllDataInSingleRequest`, 'Get', '', true);
        const json = await response.json();
        json["Countries"].map((item: any) => {
            item.value = item.CountryId;
            item.label = item.Country;
            delete item.CountryId;
            delete item.Country;
        });
        SetCountryArray(json["Countries"]);
        json["TimeZones"].map((item: any) => {
            item.value = item.SystemTimeZoneId;
            item.label = item.TimeZoneName;
            delete item.SystemTimeZoneId;
            delete item.TimeZone;
        });
        SetTimeZoneArray(json["TimeZones"]);


    }
    const handleSubmit = (e: any) => {
        if (Object.keys(selectedRecord).length > 0) {
            const selectedLanguage = formik.values.UserInterfaceLanguage;
            if (selectedLanguage) {
                i18n.changeLanguage(selectedLanguage); // Change language dynamically
            }
            dispatch(updateProfileAsync(formik.values))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                        ShowToast(t("Profile Updated Successfully"), t('Success'), "success", "toast-top-right") :
                        ShowToast(t('Error'), originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                        localStorage.setItem("showAttendanceBtn", e.IsTimeInOutAvailable);
                    //  dispatch(updateLanguage(selectedLanguage.values));

                })
                .catch((rejectedValueOrSerializedError) => {
                    // Handle the error if needed
                    ShowToast(t('Error'), t('An error occurred'), "error", "toast-top-right"); // Default error message
                });
        }

    }

    const [files1, setFiles1] = useState<File[]>([]);
    const [files2, setFiles2] = useState<File[]>([]);

    const handleDrop1 = (acceptedFiles: File[]) => {
        const formData = new FormData();
        acceptedFiles.forEach((file: File, index: number) => {

            formData.append('files' + index, file);
        });
        let param: any = {};
        param = { formData: formData };
        dispatch(UploadProfile(param))
            .then(response => {
                dispatch(getEmployeeProfileAsync());
            })
        setFiles1(acceptedFiles.map(file => Object.assign(file, {
            preview: URL.createObjectURL(file)
        })));

    };

    const handleDrop2 = (acceptedFiles: File[]) => {
        const formData = new FormData();
        acceptedFiles.forEach((file: File, index: number) => {

            formData.append('files' + index, file);
        });
        let param: any = {};
        param = { formData: formData };
        dispatch(UploadElectronicSignature(param))
            .then(response => {
            })
        setFiles2(acceptedFiles.map(file => Object.assign(file, {
            preview: URL.createObjectURL(file)
        })));
    };

    const dropzone1 = useDropzone({
        onDrop: handleDrop1,
        accept: {
            "image/*": [".png", ".gif", ".jpeg", ".jpg"],
        },
        maxSize: 5242880
    });

    const dropzone2 = useDropzone({
        onDrop: handleDrop2,
        accept: {
            "image/*": [".png", ".gif", ".jpeg", ".jpg"],
        },
        maxSize: 5242880
    });


    useEffect(() => {
        if (isReload) {
            dispatch(getEmployeeProfileAsync());
        }
    }, [isReload])


    useEffect(() => {
        renderPreferenceFields().then((result) => {
            dispatch(getEmployeeProfileAsync());
            getAttendancePermission();

        }).catch((error) => {

        });

    }, [dispatch])

    useEffect(() => {

        if (isAdminOptionShow === true) {
            dispatch(checkedshowAdminPagesState());
        } else {
            dispatch(UncheckedshowAdminPagesState());
        }
    }, [isAdminOptionShow]);



    const getAttendancePermission = async () => {
        const response = await fetchAPI('api/v2/PagePermission/PagePermissions/' + 80, 'GET', '', true);
        const json = await response.json();
        setIsAttendanceFeature(json.IsAdd);
    }

    useEffect(() => {

        let stateItem: any = {}
        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;
            Object.keys(ProfileInitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            })

            if (stateItem.AuthenticationToken === null || stateItem.AuthenticationToken == "") {
                setAuthTokenDiv(false);
            }
            else {
                setAuthTokenDiv(true);
            }
            stateItem.Password = "";

            setCurrentFieldsData(stateItem);
        }
    }, [selectedRecord])

    const handleEnableTokenOnClickEvent = () => {
        handleRegenerateOnClickEvent();
        //setAuthTokenDiv(true);
    }

    const handleRegenerateOnClickEvent = async () => {
        const response = await fetchAPI(`api/V2/Employees/AuthToken`, 'Get', '', true);
        const json = await response.json();

        formik.values.AuthenticationToken = json.AuthenticationToken[0];
        setCurrentFieldsData({ ...formik.values, 'AuthenticationToken': json.AuthenticationToken[0] });
        setAuthTokenDiv(true);
    }

    const handleDisableTokenOnClickEvent = () => {
        setAuthTokenDiv(false);
        setCurrentFieldsData({ ...formik.values, 'AuthenticationToken': '' });
    }

    const handleUpdateLanguage = () => {
        // Update language on button click
        const selectedLanguage = formik.values.UserInterfaceLanguage;
        if (selectedLanguage) {
            i18n.changeLanguage(selectedLanguage); // Change language dynamically
        }
    }
    useEffect(() => {
        const savedLanguage = localStorage.getItem("selectedLanguage");
        if (savedLanguage) {
            i18n.changeLanguage(savedLanguage); // Language ko i18n mein set karna
        }
    }, [i18n]);
    const handleBlurValidatePassword = async (setFieldTouched: any, values: any, validateForm: any, e: any = null) => {
        if (e) {
            if (e.target) {
                const email = formik.values.EMailAddress;
                const fieldName = e.target.name;
                const fieldValue = e.target.value;
                try {
                    if (fieldValue !== '') {
                        dispatch(IsCurrentPasswordValidate({ Username: email, Password: fieldValue })).then((result) => {
                            setisPasswordValidate(result.payload);

                            if (!result.payload) {
                                ShowSwalForCanvas('Current Password ', fieldValue + ' is not right', 'warning');
                                return;
                            }
                        }).catch((error) => {
                            console.error("Error during password validation", error);
                        });
                    }
                    else if (fieldValue === "" && isPasswordValidate === false) {
                        // Add your logic here
                        setisPasswordValidate(true);
                    }
                } catch (error) {
                    console.error("Error in handleBlurValidatePassword:", error);
                }
            }
        }
    };

    const handleBlurValidateEmail = async (setFieldTouched: any, values: any, validateForm: any, e: any = null) => {
        if (e) {
            if (e.target) {
                const fieldName = e.target.name;
                const fieldValue = e.target.value;
                try {
                    if (fieldValue !== '') {
                        dispatch(GetEmailAddressValidationAsync({ EMailAddress: fieldValue, AccountEmployeeId: sessionAccountEmployeeId })).then((result) => {
                            setisEmailAvailabler(result.payload);
                            setFieldTouched("emailAddress", result.payload);
                            if (!result.payload) {
                                ShowSwalForCanvas('Email Address', fieldValue + ' Email is already taken', 'warning');
                                return;
                            }
                        }).catch((error) => {
                        });
                    }
                } catch (error) {
                }
            }
        }

    }

     useEffect(() => {
        dispatch(getAccountFeatureAsync()).then((res: any) => {})
      }, [isUpdateData]);

    const CustomSelect = (props: any) => {
        return (
            <Select
                {...props}
                components={{
                    Input: (inputProps) => <components.Input {...inputProps} autoComplete="off" />,
                }}
            />
        );
    };

    return (
        <>
            {isLoading && <Loader />}
            <div className="card card-custom">
                {/* <div className="card-header sticky-top fixed-top bg-white">
                    <h3 className="card-title fw-bold headerTitle">
                         
                         {getValueFromResource('My Profile',dispatch, t)}
                         </h3>
                    <div className="card-toolbar"></div>
                </div> */}
                <div className="card-header">
                    <h3 className="card-title">{getValueFromResource('My Profile', dispatch, t)}</h3>
                    <div className="card-toolbar">
                        <button
                            type="button"
                            // className="btn btn-primary btn-bs-btn-font-weight me-2 btn-sm p-2 fs-7"
                            className="btn btn-primary btn-sm"
                            onClick={() => formik.handleSubmit()}
                            disabled={!isEmailAvailabler || !isPasswordValidate} // Button disabled condition
                            data-kt-element='send'
                        >
                            {/* {t('Update Profile')} */}
                            {getValueFromResource('Update Profile', dispatch, t)}
                        </button>
                    </div>
                </div>
                <div className="card-body mb-5">
                    <div className='row'>
                        <div className='col-md-4' style={{ width: "20%" }}>
                            <label className="fs-6 mb-1 fw">
                                {/* {t('Profile')}  */}
                                {getValueFromResource('Profile', dispatch, t)}
                            </label>
                            <p className="form-check-label fs-7" style={{ color: "rgb( 101, 111, 125 )" }}>
                                {/* {t('Your personal information and account security settings')} */}
                                {getValueFromResource('Your personal information and account security settings', dispatch, t)}
                            </p>
                        </div>
                        <div className='col-md-8'>
                            <div className='row'>
                                {/* <label className="fs-7 fs-7 fw-normal mb-1" >{t('Avatar')}</label> */}
                                <div className='d-flex align-items-center flex-shrink-0 me-5'>
                                    <div className='symbol-group symbol-hover flex-shrink-0 me-2'>
                                        <div className="symbol symbol-circle symbol-75px">
                                            {showEmployeeProfilePicture && profileURL ? (
                                                <img
                                                    // src={profileURL}
                                                    src={`${profileURL}?${new Date().getTime()}`}
                                                    className="tsReportIcon"
                                                    style={{
                                                        borderRadius: "50%",
                                                        width: "75px",
                                                        height: "75px",
                                                    }}
                                                    alt="Employee Profile"
                                                />
                                            ) : (
                                                <div
                                                    className="symbol-label fw-bold text-inverse-warning"
                                                    style={{
                                                        backgroundColor: "#006D81",
                                                        fontSize: "28px",
                                                    }}
                                                >
                                                    {formik.values.FirstName && formik.values.LastName
                                                        ? formik.values.FirstName[0].toUpperCase() +
                                                        formik.values.LastName[0].toUpperCase()
                                                        : ""}
                                                </div>
                                            )}
                                        </div>

                                    </div>
                                </div>
                            </div>
                            {IsAspNetActiveDirectoryMembershipProvider ? (
                                <div className='col-md-12 '>
                                    <div className="row">
                                        <label className="fs-7 fs-7 fw-normal mb-1">
                                            {/* {t('User Name')}  */}
                                            {getValueFromResource('User Name', dispatch, t)}
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control fs-7 fw-normal ml-1"
                                            id='Username'
                                            name='Username'
                                            value={formik.values.Username}
                                            onChange={formik.handleChange('Username')}
                                            readOnly
                                        />
                                    </div>
                                </div>
                            ) : null}
                            <div className='row spacingBetweenRows'>
                                <div className="col-md-6 ">
                                    <label className="form-label fs-7 fw">
                                        {/* {t('First Name')} */}
                                        {getValueFromResource('First Name', dispatch, t)}
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control fs-7 fw-normal"
                                        id='FirstName'
                                        name='FirstName'
                                        value={formik.values.FirstName}
                                        onChange={formik.handleChange('FirstName')}
                                        onBlur={() => formik.setFieldTouched('FirstName')}
                                    />
                                    <div >
                                        {formik.touched.FirstName && formik.errors.FirstName &&
                                            <p className='errorMsg'>{formik.errors.FirstName as string}</p>
                                        }
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <label className="form-label fs-7 fw" >
                                        {/* {t('Middle Name')} */}
                                        {getValueFromResource('Middle Name', dispatch, t)}
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control  fs-7 fw-normal"
                                        id='MiddleName'
                                        name='MiddleName'
                                        value={formik.values.MiddleName}
                                        onChange={formik.handleChange('MiddleName')}
                                    />
                                </div>
                            </div>
                            <div className='row spacingBetweenRows'>
                                <div className='col-md-6'>
                                    <label className="form-label fs-7 fw">
                                        {/* {t('Last Name')} */}
                                        {getValueFromResource('Last Name', dispatch, t)}
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control   fs-7 fw-normal"
                                        id='LastName'
                                        name='LastName'
                                        value={formik.values.LastName}
                                        onChange={formik.handleChange('LastName')}
                                        onBlur={() => formik.setFieldTouched('LastName')}
                                    />
                                    <div >
                                        {formik.touched.LastName && formik.errors.LastName &&
                                            <p className='errorMsg'>{formik.errors.LastName as string}</p>
                                        }
                                    </div>
                                </div>
                                <div className='col-md-6 '>
                                    <label className="form-label fs-7 fw">
                                        {/* {t('Email')} */}
                                        {getValueFromResource('Email', dispatch, t)}
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control   fs-7 fw-normal"
                                        id='EMailAddress'
                                        name='EMailAddress'
                                        value={formik.values.EMailAddress}
                                        onChange={formik.handleChange('EMailAddress')}
                                        /* onBlur={() => formik.setFieldTouched('EMailAddress')} */
                                        onBlur={(e: any) => handleBlurValidateEmail(formik.setFieldTouched, formik.values, formik.validateForm, e)}
                                    />
                                    <div >
                                        {formik.touched.EMailAddress && formik.errors.EMailAddress &&
                                            <p className='errorMsg'>{formik.errors.EMailAddress as string}</p>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div className='row'>
                        <div className='col-md-4' style={{ width: "20%" }}>
                            <label className="fs-6 mb-1 fw">
                                {/* {t('Language & Region')} */}
                                {getValueFromResource('Language & Region', dispatch, t)}
                            </label>
                            <p className="form-check-label fs-7" style={{ color: "rgb( 101, 111, 125 )" }}>
                                {/* {t('Customize your language and region')} */}
                                {getValueFromResource('Customize your language and region', dispatch, t)}
                            </p>
                        </div>
                        <div className='col-md-8'>
                            <div className='row '>
                                <div className='col-md-6'>
                                    <label className="form-label fs-7 fw">
                                        {/* {t('User Interface Language')} */}
                                        {getValueFromResource('User Interface Language', dispatch, t)}
                                    </label>
                                    <Select
                                        value={
                                            formik.values.UserInterfaceLanguage !== ""
                                                ? UserInterfaceLanguageOptions.find(
                                                    (option: any) => option.value === formik.values.UserInterfaceLanguage
                                                )
                                                : ""
                                        }
                                        classNamePrefix="select"
                                        name="UserInterfaceLanguage"
                                        id="UserInterfaceLanguage"
                                        isSearchable={true}
                                        onChange={(selectedOption: any) => {
                                            formik.handleChange({
                                                target: {
                                                    id: "UserInterfaceLanguage",
                                                    value: selectedOption?.value,
                                                },
                                            });
                                            localStorage.setItem("selectedLanguage", selectedOption?.value); // Language ko localStorage mein save karna
                                        }}
                                        options={UserInterfaceLanguageOptions}
                                        styles={dropDownSelectionStyles}
                                        maxMenuHeight={maxMenuHeight}
                                    />


                                </div>
                                <div className='col-md-6'>
                                    <label className="form-label fs-7 fw">
                                        {/* {t('Time Zone')} */}
                                        {getValueFromResource('Time Zone', dispatch, t)}
                                    </label>
                                    <CustomSelect
                                        value={
                                            formik.values.TimeZoneId !== ""
                                                ? TimeZoneArray.find((option: any) => option.value === formik.values.TimeZoneId)
                                                : ""
                                        }
                                        classNamePrefix="select"
                                        name="TimeZoneId"
                                        id="TimeZoneId"
                                        isSearchable={true}
                                        onChange={(selectedOption: any) => {
                                            formik.handleChange({
                                                target: {
                                                    id: "TimeZoneId",
                                                    value: selectedOption?.value,
                                                },
                                            });
                                        }}
                                        options={TimeZoneArray}
                                        styles={dropDownSelectionStyles}
                                        maxMenuHeight={maxMenuHeight}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />

                    <div className='row'>
                        <div className='col-md-4' style={{ width: "20%" }}>
                            <label className="fs-6 mb-1 fw">
                                {/* {t('Change Password')} */}
                                {getValueFromResource('Change Password', dispatch, t)}
                            </label>
                            <p className="form-check-label fs-7" style={{ color: "rgb( 101, 111, 125 )" }}>
                                {/* {t('Change your password')} */}
                                {getValueFromResource('Change your password', dispatch, t)}
                            </p>
                        </div>
                        <div className='col-md-8'>
                            <div className='row '>
                                <div className="col-md-6">
                                    <label className="form-label fs-7 fw" >
                                        {/* {t('Current Password')} */}
                                        {getValueFromResource('Current Password', dispatch, t)}
                                    </label>
                                    <input
                                        type="password"
                                        className="form-control  fs-7 fw-normal"
                                        name='Password'
                                        //onChange={formik.handleChange('Password')}
                                        onChange={formik.handleChange} // Correct usage
                                        autoComplete="new-password"
                                        onBlur={(e: any) => handleBlurValidatePassword(formik.setFieldTouched, formik.values, formik.validateForm, e)}
                                    //onBlur={() => formik.setFieldTouched('EMailAddress')}
                                    />

                                </div>

                                <div className="col-md-6">
                                    <label className="form-label fs-7 fw" >
                                        {/* {t('Password')} */}
                                        {getValueFromResource('Password', dispatch, t)}
                                    </label>
                                    <input
                                        type="password"
                                        className="form-control  fs-7 fw-normal"
                                        name='NewPassword'
                                        //onChange={formik.handleChange('NewPassword')}
                                        onChange={formik.handleChange} // Correct usage
                                        autoComplete="new-password"

                                    />

                                </div>
                            </div>
                            <div className='row spacingBetweenRows'>
                                <div className="col-md-6">
                                    <label className="form-label fs-7 fw mb-1" style={{ paddingLeft: '0px' }}>
                                        {/* {t('Verify Password')} */}
                                        {getValueFromResource('Verify Password', dispatch, t)}
                                    </label>
                                    <input
                                        type="password"
                                        className="form-control fs-7 fw-normal"
                                        name='VerifyPassword'
                                        //onChange={formik.handleChange('VerifyPassword')}
                                        onChange={formik.handleChange} // Correct usage
                                        autoComplete="new-password"
                                    />

                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div className='row'>
                        <div className='col-md-4' style={{ width: "20%" }}>
                            <label className="fs-6 mb-1 fw">
                                {/* {t('Details')} */}
                                {getValueFromResource('Details', dispatch, t)}
                            </label>
                            <p className="form-check-label fs-7" style={{ color: "rgb( 101, 111, 125 )" }}>
                                {/* {t('Specify more detail about your profile')} */}
                                {getValueFromResource('Specify more detail about your profile', dispatch, t)}
                            </p>
                        </div>
                        <div className='col-md-8'>
                            <div className='row '>
                                <div className="col-md-6 ">
                                    <label className="form-label fs-7 fw mb-1" style={{ paddingLeft: '0px' }}>
                                        {/* {t('Address Line 1')} */}
                                        {getValueFromResource('Address Line 1', dispatch, t)}
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control  fs-7 fw-normal"
                                        id='AddressLine1'
                                        name='AddressLine1'
                                        value={formik.values.AddressLine1}
                                        onChange={formik.handleChange('AddressLine1')}

                                    />

                                </div>

                                <div className="col-md-6 ">
                                    <label className="form-label fs-7 fw mb-1" style={{ paddingLeft: '0px' }}>
                                        {/* {t('Address Line 2')} */}
                                        {getValueFromResource('Address Line 2', dispatch, t)}
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control  fs-7 fw-normal"
                                        id='AddressLine2'
                                        name='AddressLine2'
                                        value={formik.values.AddressLine2}
                                        onChange={formik.handleChange('AddressLine2')}

                                    />

                                </div>
                            </div>

                            <div className='row spacingBetweenRows'>
                                <div className="col-md-6 ">
                                    <label className="form-label fs-7 fw mb-1" style={{ paddingLeft: '0px' }}>
                                        {/* {t('State')} */}
                                        {getValueFromResource('State', dispatch, t)}
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control  fs-7 fw-normal"
                                        id='State'
                                        name='State'
                                        value={formik.values.State}
                                        onChange={formik.handleChange('State')}
                                    />

                                </div>

                                <div className="col-md-6 ">
                                    <label className="form-label fs-7 fw mb-1" style={{ paddingLeft: '0px' }}>
                                        {/* {t('City')} */}
                                        {getValueFromResource('City', dispatch, t)}
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control  fs-7 fw-normal"
                                        id='City'
                                        name='City'
                                        value={formik.values.City}
                                        onChange={formik.handleChange('City')}
                                    />

                                </div>
                            </div>

                            <div className='row spacingBetweenRows'>
                                <div className="col-md-6 ">
                                    <label className="form-label fs-7 fw mb-1" style={{ paddingLeft: '0px' }}>
                                        {/* {t('Zip Code')} */}
                                        {getValueFromResource('Zip Code', dispatch, t)}
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control  fs-7 fw-normal"
                                        id='Zip'
                                        name='Zip'
                                        value={formik.values.Zip}
                                        onChange={formik.handleChange('Zip')}
                                    />

                                </div>

                                <div className="col-md-6 ">
                                    <label className="form-label fs-7 fw mb-1" style={{ paddingLeft: '0px' }}>
                                        {/* {t('Mobile Phone No')} */}
                                        {getValueFromResource('Mobile Phone No', dispatch, t)}
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control  fs-7 fw-normal"
                                        id='MobilePhoneNo'
                                        name='MobilePhoneNo'
                                        value={formik.values.MobilePhoneNo}
                                        onChange={formik.handleChange('MobilePhoneNo')}
                                    />

                                </div>
                            </div>

                            <div className='row spacingBetweenRows'>
                                <div className="col-md-6 ">
                                    <label className="form-label fs-7 fw mb-1" style={{ paddingLeft: '0px' }}>
                                        {/* {t('Home Phone No')} */}
                                        {getValueFromResource('Home Phone No', dispatch, t)}
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control  fs-7 fw-normal"
                                        id='HomePhoneNo'
                                        name='HomePhoneNo'
                                        value={formik.values.HomePhoneNo}
                                        onChange={formik.handleChange('HomePhoneNo')}
                                    />

                                </div>

                                <div className="col-md-6 ">
                                    <label className="form-label fs-7 fw mb-1" style={{ paddingLeft: '0px' }}>
                                        {/* {t('Country')} */}
                                        {getValueFromResource('Country', dispatch, t)}
                                    </label>
                                    <Select
                                        value={formik.values.CountryId != "" ? countryArray.find((option: any) => option.value == formik.values.CountryId) : ""}
                                        classNamePrefix="select"
                                        name="CountryId"
                                        id="CountryId"
                                        isSearchable={true}
                                        onChange={(selectedOption: any) => {

                                            formik.handleChange({
                                                target: {
                                                    id: "CountryId",
                                                    value: selectedOption?.value
                                                },

                                            });
                                        }}
                                        options={countryArray}
                                        styles={dropDownSelectionStyles}
                                        maxMenuHeight={maxMenuHeight}
                                    />

                                </div>
                            </div>
                            <div className='row spacingBetweenRows'>
                                <div className="col-md-6 ">
                                    <label className="form-label fs-7 fw mb-1" style={{ paddingLeft: '0px' }}>
                                        {/* {t('Work Phone No')} */}
                                        {getValueFromResource('Work Phone No', dispatch, t)}
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control  fs-7 fw-normal"
                                        id='WorkPhoneNo'
                                        name='WorkPhoneNo'
                                        value={formik.values.WorkPhoneNo}
                                        onChange={formik.handleChange('WorkPhoneNo')}

                                    />

                                </div>
                            </div>

                        </div>
                    </div>
                    <hr />
                    <div className='row'>
                        <div className='col-md-4' style={{ width: "20%" }}>
                            <label className="fs-6 mb-1 fw">
                                {/* {t('Others')} */}
                                {getValueFromResource('Others', dispatch, t)}
                            </label>
                            <p className="form-check-label fs-7" style={{ color: "rgb( 101, 111, 125 )" }}>
                                {/* {t('Update others')} */}
                                {getValueFromResource('Update others', dispatch, t)}
                            </p>
                        </div>
                        <div className='col-md-8'>
                            {enableUploadFeature ? (
                                <div className='row'>
                                    <div className="col-md-6 ">
                                        <label className="form-label fs-7 fw mb-1" style={{ paddingLeft: '0px' }}>
                                            {/* {t('Profile Picture')} */}
                                            {getValueFromResource('Profile Picture', dispatch, t)}
                                        </label>
                                        <div {...dropzone1.getRootProps({ className: 'dropzone' })} style={{ display: 'flex', alignItems: 'center' }}>
                                            <input {...dropzone1.getInputProps()} />
                                            <p>
                                                {/* {t('Drag n drop some files here, or click to select files')} */}
                                                {getValueFromResource('Drag n drop some files here, or click to select files', dispatch, t)}
                                                <br></br><b>
                                                    {/* {t('Max File Size is 5MB')} */}
                                                    {getValueFromResource('Max File Size is 5MB', dispatch, t)}
                                                </b></p>

                                            {files1[0] && (
                                                <div style={{ marginLeft: '50px' }}>
                                                    {files1[0].type.startsWith('image/') ? (
                                                        <img
                                                            src={URL.createObjectURL(files1[0])}
                                                            alt={files1[0].name}
                                                            style={{ maxWidth: '100%', maxHeight: '100px' }}
                                                        />
                                                    ) : (
                                                        <p>{files1[0].name}</p>
                                                    )}
                                                </div>
                                            )}
                                        </div>

                                    </div>




                                    <div className="col-md-6 ">
                                        <label className="form-label fs-7 fw mb-1" style={{ paddingLeft: '0px' }}>
                                            {/* {t('Electronic Signature')} */}
                                            {getValueFromResource('Electronic Signature', dispatch, t)}
                                        </label>
                                        <div {...dropzone2.getRootProps({ className: 'dropzone' })} style={{ display: 'flex', alignItems: 'center' }}>
                                            <input {...dropzone2.getInputProps()} />
                                            <p>
                                                {/* {t('Drag n drop some files here, or click to select files')} */}
                                                {getValueFromResource('Drag n drop some files here, or click to select files', dispatch, t)}
                                                <br></br><b>
                                                    {/* {t('Max File Size is 5MB')} */}
                                                    {getValueFromResource('Max File Size is 5MB', dispatch, t)}
                                                </b></p>

                                            {files2[0] && (
                                                <div style={{ marginLeft: '50px' }}>
                                                    {files2[0].type.startsWith('image/') ? (
                                                        <img
                                                            src={URL.createObjectURL(files2[0])}
                                                            alt={files2[0].name}
                                                            style={{ maxWidth: '100%', maxHeight: '100px' }}
                                                        />
                                                    ) : (
                                                        <p>{files2[0].name}</p>
                                                    )}
                                                </div>
                                            )}
                                        </div>

                                    </div>
                                </div>

                            ) : null}


                            <hr className="pt-1 pb-1 mt-1 mb-1" />
                            {enableUploadFeature ? (
                                <div className="row">
                                    <div className="col-lg-12 " id="divCheckBox" style={{ display: 'flex' }}>
                                        <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                            <input className="form-check-input custom-padding-right h-20px w-40px"
                                                type="checkbox" checked={formik.values.IsShowEmployeeProfilePicture} id="IsShowEmployeeProfilePicture"
                                                onChange={formik.handleChange('IsShowEmployeeProfilePicture')}

                                            />

                                        </div>
                                        <div className="">
                                            <label className="form-label fs-7 fw mb-1" style={{ paddingLeft: '0px' }}>
                                                {/* {t('Show Employee Profile Picture')} */}
                                                {getValueFromResource('Show Employee Profile Picture', dispatch, t)}
                                            </label>
                                            <p className="form-check-label fs-7">
                                                {/* {t('This option allow user profile picture to be visible in Project and task team and user account.This check will enable Time In and Time Out buttons for all users. Through this, users attendance log will be created in Day View.')} */}
                                                {getValueFromResource('This option allow user profile picture to be visible in Project and task team and user account', dispatch, t)}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                            {( isEnableAttandance) ? (
                                <>
                                    <hr className="pt-1 pb-1 mt-1 mb-1" />
                                    <div className="row">
                                        <div className="col-lg-12 " id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                            <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                <input className="form-check-input custom-padding-right h-20px w-40px"
                                                    type="checkbox" checked={formik.values.IsTimeInOutAvailable} id="IsTimeInOutAvailable"
                                                    onChange={formik.handleChange('IsTimeInOutAvailable')}
                                                />

                                            </div>
                                            <div className="">
                                                <label className="fs-7 fw mb-1" style={{ paddingLeft: '0px' }}>
                                                    {/* {t('Enable Time In/Out Option')} */}
                                                    {getValueFromResource('Enable Time In/Out Option', dispatch, t)}
                                                </label>
                                                <p className="form-check-label fs-7">
                                                    {/* {t('This check will enable Time In and Time Out buttons for all users. Through this, users attendance log will be created in Day View')} */}
                                                    {getValueFromResource('This check will enable Time In and Time Out buttons for all users. Through this, users attendance log will be created in Day View', dispatch, t)}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : null}
                        </div>
                    </div>
                    <hr />
                    <div className='row'>
                        <div className='col-md-4' style={{ width: "20%" }}>
                            <label className="fs-6 mb-1 fw" >
                                {/* {t('API')} */}
                                {getValueFromResource('API', dispatch, t)}
                            </label>
                            <p className="form-check-label fs-7" style={{ color: "rgb( 101, 111, 125 )" }}><b>
                                {/* {t('Authentication Token')} */}
                                {getValueFromResource('Authentication Token', dispatch, t)}
                            </b>
                                <br />
                                {/* {t('Your Authentication Token is a code you can type into certain products to allow the third party product access your TimeLive data')} */}
                                {getValueFromResource('Your Authentication Token is a code you can type into certain products to allow the third party product access your TimeLive data', dispatch, t)}
                            </p>
                        </div>
                        {authTokenDiv ? (
                            <div className='col-md-8' >
                                <div className='row' >
                                    <div className='col-md-6 mt-9'>

                                        <input
                                            type="text"
                                            className="form-control fs-7 fw-normal"
                                            id='AuthenticationToken'
                                            name='AuthenticationToken'
                                            value={formik.values.AuthenticationToken}
                                            onChange={formik.handleChange('AuthenticationToken')}
                                            readOnly
                                        />
                                    </div>
                                    <div className='col-md-4 mt-9'>

                                        <button type='button' className="btn btn-primary  btn-bs-btn-font-weight btn-sm me-1" style={{ marginRight: '1px' }} onClick={() => handleRegenerateOnClickEvent()}>
                                            {/* {t('Regenerate')} */}
                                            {getValueFromResource('Regenerate', dispatch, t)}
                                        </button>

                                        <button type='button' className="btn btn-danger btn-sm" onClick={() => handleDisableTokenOnClickEvent()} >
                                            {/* {t('Disable Token')} */}
                                            {getValueFromResource('Disable Token', dispatch, t)}
                                        </button>
                                    </div>

                                </div>
                            </div>
                        ) :
                            // <div className='col-md-1 m-5'>
                            //     <div className='row' >
                            //         <button type='button' className="btn btn-primary btn-sm" onClick={() => handleEnableTokenOnClickEvent()} >
                            //             {/* {t('Enable Token')} */}
                            //             {getValueFromResource('Enable Token',dispatch, t)}
                            //             </button>
                            //     </div>
                            // </div>
                            <div className='col-md-3 mt-9'>
                                <button
                                    type='button'
                                    className="btn btn-primary btn-sm custom-button"
                                    onClick={() => handleEnableTokenOnClickEvent()}
                                >
                                    {getValueFromResource('Enable Token', dispatch, t)}
                                </button>
                            </div>
                        }
                    </div>

                </div>
                {/* <div className='card-footer pt-4' style={{ marginBottom: '55px' }}>
                    <div className='d-flex flex-stack float-end'>
                        <div className='d-flex align-items-center me-2'>
                            <button
                                type="button"
                                // className="btn btn-primary btn-bs-btn-font-weight me-2 btn-sm p-2 fs-7"
                                className="btn btn-primary btn-sm"
                                onClick={() => formik.handleSubmit()}
                                disabled={!isEmailAvailabler || !isPasswordValidate} // Button disabled condition
                                data-kt-element='send'
                            >
                                {getValueFromResource('Update Profile', dispatch, t)}
                            </button>
                        </div>
                    </div>
                </div> */}
            </div>

        </>
    )
}


